import React, {useState} from 'react';
import placeholderImg from "../../assets/loading.png"
// import DevelopTools from '../../assets/Untitled design.png';
import react from "../../assets/atom.png"
import sqlserver from "../../assets/sql-server.png"
import python from "../../assets/python.png"
import html from "../../assets/html.png"
import css from "../../assets/css-3.png"
import javascript from "../../assets/js.png"
import figma from "../../assets/figma.png"
import shopify from "../../assets/shopify.png"
import tailwind from "../../assets/tailwind-css.png"
import mongo from "../../assets/mongodb.png"
import powerbi from "../../assets/powerbi.png"

import mobilereact from "../../assets/Black Logos/atom.png"
import mobilesqlserver from "../../assets/Black Logos/sql-server.png"
import mobilepython from "../../assets/Black Logos/python.png"
import mobilehtml from "../../assets/Black Logos/html.png"
import mobilecss from "../../assets/Black Logos/css-3.png"
import mobilejavascript from "../../assets/Black Logos/js.png"
import mobilefigma from "../../assets/Black Logos/figma.png"
import mobileshopify from "../../assets/Black Logos/shopify.png"
import mobiletailwind from "../../assets/Black Logos/tailwind-css.svg"
import mobilemongo from "../../assets/Black Logos/mongodb.svg"
import mobilepowerbi from "../../assets/Black Logos/powerbi.png"

function TechSection() {
  const [loading, setLoading] = useState(true);

  const handleImageLoaded = () => {
    setLoading(false);
  }

  const boxes = [
    {
      id: 1,
      name: "SQL Server",
      image: sqlserver,
      mobileImage: mobilesqlserver
    },
    {
      id: 2,
      name: "Figma",
      image: figma,
      mobileImage: mobilefigma
    },
    {
      id: 3,
      name: "Python",
      image: python,
      mobileImage: mobilepython
    },
    {
      id: 4,
      name: "JavaScript",
      image: javascript,
      mobileImage: mobilejavascript

    },
    {
      id: 5,
      name: "CSS",
      image: css,
      mobileImage: mobilecss

    },
    {
      id: 6,
      name: "React",
      image: react,
      mobileImage: mobilereact

    },
    {
      id: 7,
      name: "HTML",
      image: html,
      mobileImage: mobilehtml

    },
    {
      id: 8,
      name: "Shopify",
      image: shopify,
      mobileImage: mobileshopify

    },
    {
      id: 9,
      name: "Tailwind CSS",
      image: tailwind,
      mobileImage: mobiletailwind

    },
    {
      id: 10,
      name: "MongoDB",
      image: mongo,
      mobileImage: mobilemongo

    },
    {
      id: 11,
      name: "Power BI",
      image: powerbi,
      mobileImage: mobilepowerbi

    }
  ]

  return (
  //   <section className="w-full content-center m-auto bg-gray-200 h-fit border-black">
  //       <img fetchpriority="high" decoding="async" width="100%" height="172" src={DevelopTools} alt="Development tools"></img>
  // </section>
  
  <section className='flex flex-wrap sm:px-16 md:px-54 mb-16 md:mt-2  place-content-center'>
    {boxes.map((item) => (
      <div key={item.id} className="sm:max-h-[60px] sm:max-w-[60px] md:max-h-[80px] md:max-w-[80px] mx-3 my-3 inline-block mr-[4px] rounded-[2px] sm:odd:mt-0 xl:odd:mt-28">
        {loading && <img src={placeholderImg} className='m-auto animate-spin max-h-[2rem]' alt="loading"/>}
        <img src={item.mobileImage} alt={item.name} className={`${item.id === 6 ? "animate-spin-slow": ""}`} onLoad={handleImageLoaded}/>
      </div>
    ))}
  </section>

  )
}

export default TechSection